import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
	WorkstationConfiguration,
	WorkstationConfigurationService
} from "../../../../services/back/workstation-configuration.service";
import {Subscription} from "rxjs";
import {WorkstationDetailData, WorkstationDetailService} from "../../../../services/front/workstation-detail.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {SnackbarService} from "../../../../services/front/snackbar.service";
import {MatDialog} from "@angular/material/dialog";
import {WorkstationUrlService} from "../../../../services/front/workstation-url.service";
import {tap} from "rxjs/operators";
import {DesignSystemModule} from "../../../design-system/design-system.module";
import {NgIf} from "@angular/common";
import {SnackbarModule} from "../../../global/snackbar/snackbar.module";
import {TabModule} from "../../../global/tabs/tab/tab.module";
import {TabsModule} from "../../../global/tabs/tabs.module";
import {TitleContentLoaderComponent} from "../../../global/title-content-loader/title-content-loader.component";
import {WorkstationOverviewTabComponent} from "./workstation-overview-tab/workstation-overview-tab.component";

@Component({
  selector: 'app-workstation-detail',
	imports: [
		DesignSystemModule,
		NgIf,
		SnackbarModule,
		TabModule,
		TabsModule,
		TitleContentLoaderComponent,
		TranslateModule,
		WorkstationOverviewTabComponent
	],
  templateUrl: './workstation-detail.component.html',
  styleUrl: './workstation-detail.component.scss'
})
export class WorkstationDetailComponent implements OnInit, OnDestroy {
	@Input() data: WorkstationDetailInput;
	@Output() onClose = new EventEmitter<void>();

	tenantId: string;
	isEditor: boolean;
	workstation: WorkstationConfiguration;

	_initializing: boolean;

	sliderIndex: number = 1;
	lazyLoadedTabs: boolean[] = [false];

	subscriptions: Subscription = new Subscription();

	constructor(private workstationDetailService: WorkstationDetailService,
				private workstationUrlService: WorkstationUrlService,
				private activatedRoute: ActivatedRoute,
				private translate: TranslateService,
				private workstationService: WorkstationConfigurationService,
				private snackbar: SnackbarService,
				private dialog: MatDialog,
				private router: Router) {
	}

	ngOnInit() {
		this.router.navigate([], {queryParams: {workstationId: this.data.workstationId}, queryParamsHandling: 'merge'});

		this.sliderIndex = this.workstationUrlService.getCurrentWorkstationTab();
		this.lazyLoadedTabs[this.sliderIndex] = true;

		this.workstationDetailService.initialize(this.data.workstationId);

		this.subscriptions.add(this.workstationDetailService.getInitializingChanges()
			.subscribe(initializing => this._initializing = initializing));

		this.subscriptions.add(this.workstationDetailService.getWorkstationDetailDataChanges()
			.pipe(tap(data => this.setWorkstationDetailData(data)))
			.subscribe());
	}

	private setWorkstationDetailData(data: WorkstationDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
		this.workstation = data.workstation;
	}

	close(): void {
		this.onClose.emit();
	}

	onSliderChange(index: number): void {
		this.sliderIndex = index;
		this.lazyLoadedTabs[index] = true;
		this.workstationUrlService.changeCurrentWorkstationTab(index);
	}

	ngOnDestroy() {
		this.workstationUrlService.changeCurrentWorkstation(null);
		this.workstationDetailService.clearWorkstationDetailData();
		this.subscriptions.unsubscribe();
	}
}

export interface WorkstationDetailInput {
	workstationId: string;
}
